import { useCallback, useLayoutEffect, useRef } from 'react';

export function useLatestCallback<T extends (...args: any[]) => any>(
  callback: T,
): (...args: Parameters<T>) => ReturnType<T> {
  const callbackRef = useRef(callback);

  // useLayoutEffect (no deps) ensures the ref is updated synchronously after
  // every commit, before any pending browser paint, so a click handler that
  // fires in the same frame always calls the latest version of the callback.
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback(
    (...args: Parameters<T>): ReturnType<T> => callbackRef.current(...args),
    [],
  );
}
